import React from 'react';
import { useDispatch } from 'react-redux';
import Popup from 'reactjs-popup';

import css from '../../css/sidebar/header.module.scss';
import { ReactComponent as Down } from '../../img/common/arrowDown.svg';
import { ReactComponent as Info } from '../../img/sidebar/header/info.svg';
import { ReactComponent as Logo } from '../../img/sidebar/header/logo.svg';
import { logout } from '../../slice/userSlice';

export const Header: React.FC = () => {
    const dispatch = useDispatch();
    const popup = (
        <div className={css.popup}>
            <a href="https://paralleljp.studio.site/guide/pc" target="_blank" rel="noopener noreferrer">
                <p>よくある質問</p>
            </a>
            <hr />
            <a href="https://www.reactcorp.com/privacy_policy.html" target="_blank" rel="noopener noreferrer">
                <p>プライバシーポリシー</p>
            </a>
            <a href="https://www.reactcorp.com/term.html" target="_blank" rel="noopener noreferrer">
                <p>利用規約</p>
            </a>
            <hr />
            <p className={css.logout} onClick={() => dispatch(logout())}>
                ログアウト
            </p>
            <hr />
            <div className={css.info}>
                <Info height="13.3" width="13.3" />
                <p>設定はスマホアプリからのみ対応しています</p>
            </div>
        </div>
    );
    return (
        <div className={css.header}>
            <Logo height="24" width="109" />
            <Popup
                trigger={<Down height="16" width="16" className={css.down} />}
                position="bottom center"
                arrow={false}
                offsetX={21 + 8}
                offsetY={16}
            >
                {popup}
            </Popup>
        </div>
    );
};
